/* @ngInject */
function ContactFactory($http, $rootScope) {
  class Contact {
    constructor(data) {
      this._id = null;
      this.firstName = null;
      this.lastName = null;
      this.appointment = null;
      this.company = null;
      this.nif = null;
      this.email = null;
      this.primaryPhone = null;
      this.secondaryPhone = null;
      this.addressLine1 = null;
      this.addressLine2 = null;
      this.city = null;
      this.stateOrProvince = null;
      this.country = null;
      this.zipOrPostalCode = null;
      this.currency = null;
      this.color = null;
      this.createdAt = null;
      this.updatedAt = null;
      this.deletedAt = null;

      if (data) this.setData(data);
    }

    static getResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/contacts`;
    }

    setData(data) {
      if (angular.isString(data)) {
        this._id = data;
        return;
      }

      this._id = data._id;
      this.firstName = data.firstName;
      this.firstNameCanonical = data.firstNameCanonical;
      this.lastName = data.lastName;
      this.appointment = data.appointment;
      this.company = data.company;
      this.nif = data.nif;
      this.email = data.email;
      this.primaryPhone = data.primaryPhone;
      this.secondaryPhone = data.secondaryPhone;
      this.addressLine1 = data.addressLine1;
      this.addressLine2 = data.addressLine2;
      this.city = data.city;
      this.stateOrProvince = data.stateOrProvince;
      this.country = data.country;
      this.zipOrPostalCode = data.zipOrPostalCode;
      this.currency = data.currency;
      this.color = data.color;
      this.createdAt = data.createdAt;
      this.updatedAt = data.updatedAt;
      this.deletedAt = data.deletedAt;
    }

    isNew() {
      return !this._id;
    }

    sendPartial() {
      return {
        firstName: this.firstName,
        lastName: this.lastName,
        appointment: this.appointment,
        company: this.company,
        nif: this.nif,
        email: this.email,
        primaryPhone: this.primaryPhone,
        secondaryPhone: this.secondaryPhone,
        addressLine1: this.addressLine1,
        addressLine2: this.addressLine2,
        city: this.city,
        stateOrProvince: this.stateOrProvince,
        country: this.country,
        zipOrPostalCode: this.zipOrPostalCode,
        currency: this.currency,
      };
    }

    fullName() {
      return `${this.firstName} ${this.lastName || ""}`.trim();
    }

    static query(params) {
      return $http
        .get(Contact.getResourceUrl(), { params })
        .then((response) => response.data.map((contactData) => new Contact(contactData)));
    }

    save() {
      return this.isNew() ? this.create() : this.update();
    }

    create() {
      if (!this.isNew()) throw new Error("The contact is already created");

      return $http.post(Contact.getResourceUrl(), this.sendPartial()).then((response) => this.setData(response.data));
    }

    update() {
      if (this.isNew()) throw new Error("Can not update a contact that has not been created");

      return $http
        .put(`${Contact.getResourceUrl()}/${this._id}`, this.sendPartial())
        .then((response) => this.setData(response.data));
    }

    delete() {
      if (this.isNew()) throw new Error("Can not delete a contact that has not been created");

      return $http.delete(`${Contact.getResourceUrl()}/${this._id}`).then(() => true);
    }
  }

  return Contact;
}

export default ContactFactory;
